module.exports = __webpack_public_path__ + "img/Molnify.23a7097a.png";